import moment from 'moment'

export default {
  install: Vue => {
    // 格式化时间通用过滤器, example:
    // {{ item.time | formatTime }}  => '2018-12-12'
    // {{ item.time | formatTime('YYYY-MM-DD HH:mm:ss') }}  => '2018-12-12 12:22:34'  HH大写是24小时制，小写是12小时制
    Vue.filter('formatTime', (time, format = 'YYYY-MM-DD') => {
      const date = new Date(time)
      if (moment.isDate(date)) {
        return moment(time).format(format)
      }
      return ''
    })
    Vue.filter('formatPrice', (price = 0, format = 2) => {
      return Number((+price / 100).toFixed(format))
    })
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js